import api from "./api";

/**
 * Managed alerts (spec 08). The server scopes every call to what the reader
 * may see and do; this only moves data.
 */

/** GET /business/alerts — filters: status[], type[], severity[], branches, assignee, page. */
export const fetchAlerts = async (filters = {}, page = 1) => {
  const params = { page, per_page: 25 };

  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value) ? value.length : value) params[key] = value;
  });

  const { data } = await api.get("/business/alerts", { params });

  return data;
};

export const fetchAlert = async (id) => (await api.get(`/business/alerts/${id}`)).data.data;

/** PATCH /business/alerts/{id} — action: acknowledge | assign | resolve | dismiss | reopen. */
export const updateAlert = async (id, payload) =>
  (await api.patch(`/business/alerts/${id}`, payload)).data.data;

/** POST /business/alerts/bulk — action: acknowledge | resolve | dismiss. */
export const bulkAlerts = async (ids, action, note) =>
  (await api.post("/business/alerts/bulk", { ids, action, ...(note ? { note } : {}) })).data.data;

export const fetchAlertAssignees = async () => (await api.get("/business/alerts/assignees")).data.data;

export const fetchAlertSettings = async () => (await api.get("/business/alerts/settings")).data.data;

export const saveAlertSettings = async (settings) =>
  (await api.put("/business/alerts/settings", settings)).data.data;

export const refreshAlerts = async () => (await api.post("/business/alerts/refresh")).data.data;
